import React, { FC } from 'react';
import { LinearProgress } from '@mui/material';

interface OvVideoUploadProgressProps {
  label: string;
  percent?: number;
}

const OvVideoUploadProgress: FC<OvVideoUploadProgressProps> = ({
  label,
  percent,
}) => (
  <LinearProgress
    variant={percent === undefined ? 'indeterminate' : 'determinate'}
    value={percent}
    aria-label={label}
  />
);

export default OvVideoUploadProgress;
